import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ClientHeaderComponent } from './client-header.component';


const routes: Routes = [
  {
    path: '',
    component: ClientHeaderComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientHeaderRoutingModule { }
